export default {
  paymentResult: {},

  transits: [],
  transit: {},
  transitCode: null,

  fieldReports: [],
  fieldReport: {},
  fieldReportCode: null,

  meterReadings: [],
  meterReadingCode: null,
  meterReadingAdminCode: null,

  waterBills: [],
  waterBill: {},
  waterBillCode: null,

  chargeBills: [],
  chargeBill: {},
  chargeBillCode: null,

  automations: [],
  automation: {},
  automationCode: null,
  automationCartable: [],

  serviceRequests: [],
  serviceRequest: {},
  serviceRequestCode: null,

  billboardRequests: [],
  billboardRequest: {},
  billboardRequestCode: null,
  billboardRequestAdminCode: null,
  billboardReserveDate: [],
  isBillboardReserveDate: false,

  transactions: [],
  lastVoucherInfo: {},
};
